export const COLUMNS = [
    { key: "active", label: "", sortable: false },
    { key: "serviceName", label: "Service", sortable: true },
    { key: "categoryName", label: "Category", sortable: true },
    { key: "type", label: "Service type", sortable: true },
    { key: "capacity", label: "Capacity", sortable: true },
    { key: "sessions", label: "# of sessions", sortable: true },
    { key: "locations", label: "Available locations", sortable: true },
    { key: "duration", label: "Duration (mins)", sortable: true },
    { key: "bookingBehaviour", label: "Booking type", sortable: true },
    { key: "taxExempt", label: "Tax exempt", sortable: true },
    { key: "price", label: "Price", sortable: true }
];
